import { PolicyDetailScreen } from "@softmax/web-ux/policies";
import { buildHref } from "@softmax/web-addresses";

export function PolicyPending() {
  return (
    <PolicyDetailScreen
      back={{ href: buildHref({ name: "policies" }), label: "Policies" }}
      state={{ status: "loading" }}
    />
  );
}
